import React from "react"
import {Checkbox, Collapse, Drawer, FormGroup} from "@mui/material"

import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Divider from "@mui/material/Divider"
import List from "@mui/material/List"
import MenuList from "@mui/material/MenuList"
import ListItem from "@mui/material/ListItem"
import ListItemIcon from "@mui/material/ListItemIcon"
import FormControl from "@mui/material/FormControl"
import Box from '@mui/material/Box'
import ListItemText from "@mui/material/ListItemText"
import {setDrawerOpen, setDrawerItem, setGroupSelection} from "./slice"
import {useDispatch, useSelector} from "react-redux"
import {ExpandLess, ExpandMore} from "@mui/icons-material"
import PersonPinIcon from '@mui/icons-material/PersonPin'
import {GET_TECHNIQUES_TREE, GET_INSTRUCTORS} from "./graphql"
import {useLazyQuery, useQuery} from "@apollo/client"
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary'
import Tornado from '@mui/icons-material/Tornado'
import FavoriteIcon from '@mui/icons-material/Favorite'
import HomeIcon from '@mui/icons-material/Home'
import HistoryIcon from '@mui/icons-material/History'
import SpokeIcon from '@mui/icons-material/Spoke'

import {toggleSearchParams} from "./utils"

import {useLocation, useNavigate, useSearchParams} from "react-router-dom"
import Spinner from "../../../global/Spinner"
import MenuItem from "@mui/material/MenuItem"


function DashboardDrawer(props) {
    const container = window !== undefined ? () => window.document.body : undefined;
    const {drawerWidth} = props
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const drawerOpen = useSelector(state => state.drawer.drawerOpen)
    const drawerItems = useSelector(state => state.drawer.drawerItems)
    const dispatch = useDispatch()
    const user = useSelector(state => state.global.user)

    const location = useLocation()

    const paddingBottom = (user.subscribed) ? 12 : 0

    const {
        data: taxData,
        loading: taxLoading,
        error: taxError
    } = useQuery(GET_TECHNIQUES_TREE, {
        variables: {
            "parent": "Classes"
        }
    })
    const {taxonomyChildren: classes} = taxData ? taxData : {taxonomyChildren: {}}

    const [getInstructors, {data: insData, loading: insLoading, error: insError}] = useLazyQuery(GET_INSTRUCTORS,
        {
            variables: {
                "cid": searchParams.get('categories'),
                "tid": searchParams.get('techniques')
            }
        })
    const {instructors} = insData ? insData : {instructors: {}}

    const {
        data: techniqueData,
    } = useQuery(GET_TECHNIQUES_TREE, {
        variables: {
            "parent": "Techniques"
        }
    })
    const {taxonomyChildren: techniquesData} = techniqueData ? techniqueData : {taxonomyChildren: {}}

    const findParent = (parentName, tree) => {
        const parent = Number.isInteger(parentName) ? tree.filter(item => item['id'] === parentName) : tree.filter(item => item['name'] === parentName)
        return parent.length > 0 ? parent[0]['children'] : []
    }

    const findCorrelatedId = (parentId) => {
        const classedId = classes.filter(item => item['id'] === parentId)
        if (classedId.length > 0) {
            const techniques = techniquesData.filter(item => item['name'] === classedId[0]['name'])
            return techniques.length > 0 ? techniques[0]['children'] : []
        } else {
            return []
        }
    }

    const amSelected = (param, value) => {
        const paramValue = searchParams.get(param)
        if (param.toLowerCase() === 'categories' && searchParams.get('techniques')) {
            return false
        } else if (paramValue) {
            const items = paramValue.split(',')
            return !!items.includes(value)
        } else
            return false
    }

    /**
     * Updates the query after an instructor has been clicked.
     * @param event
     */
    const handleInstructorChange = event => {
        searchParams.set('pageNum', 1)
        const adjustedParams = toggleSearchParams('instructors', event.currentTarget.value, searchParams)
        setSearchParams(adjustedParams)
    }

    const handleClassChildSelect = event => {
        const value = event.target.value
        if (value) {
            searchParams.delete('pageNum')
            searchParams.delete('instructors')
            searchParams.delete('techniques')
            searchParams.delete('pageNum')
            searchParams.delete('q')
            searchParams.set('categories', value)
            // const adjustedParams = toggleSearchParams('categories', value, searchParams)
            navigate({
                pathname: '/search',
                search: `?${searchParams.toString()}`
            })
        }
    }
    const handleTechniqueSelect = event => {
        const value = event.target.value
        if (value) {
            searchParams.delete('pageNum')
            searchParams.delete('instructors')
            searchParams.delete('pageNum')
            searchParams.delete('q')
            searchParams.set('techniques', value)
            // const adjustedParams = toggleSearchParams('categories', value, searchParams)
            navigate({
                pathname: '/search',
                search: `?${searchParams.toString()}`
            })
        }
    }

    /**
     *  Determines if an instructor should be checkd by examinig the query
     * @param id
     * @returns {boolean}
     */
    const instructorCheck = (id) => {
        let result = false
        searchParams.forEach((value, key) => {
            if (key === 'instructors') {
                const instructor_list = value.split(',').map(item => parseInt(item))
                if (instructor_list.includes(parseInt(id))) {
                    result = true
                }
            }
        })
        return result
    }


    const MemoMenu = React.memo(() => {
        const hasCategory = searchParams.get('categories')
        const parent = hasCategory ? hasCategory : 'Techniques'
        const techniquesList = searchParams.get('categories') ? findCorrelatedId(parent) : findParent(parent, techniquesData)
        return (
            techniquesList.map((item, index) => (
                <RadioGroup key={`technique-parent-${item.id}-${index}`}>

                    <MenuItem sx={{ml: 4}}>
                        <FormControlLabel value={item.id}
                                          checked={amSelected('techniques', item.id)}
                                          control={<Radio/>}
                                          label={`${item.name}`}
                                          onChange={handleTechniqueSelect}/>
                    </MenuItem>
                </RadioGroup>
            ))
        )
    })

    const drawer = (
        <Box sx={{pb: paddingBottom}}>
            <MenuList>
                <MenuItem onClick={() => {
                    dispatch(setGroupSelection(''))
                    navigate('/dashboard')
                }}
                          selected={(location.pathname === '/dashboard') ? true : false}
                >
                    <ListItemIcon>
                        <HomeIcon/>
                    </ListItemIcon>
                    <ListItemText primary='Dashboard'/>
                </MenuItem>
                <Divider/>

            </MenuList>
            <MenuList>
                <MenuItem onClick={() => {
                    dispatch(setDrawerItem({item: 'library', value: drawerItems.library}))
                }}
                          selected={(location.pathname.indexOf('/library') > -1) ? true : false}
                >
                    <ListItemIcon>
                        <VideoLibraryIcon/>
                    </ListItemIcon>
                    <ListItemText primary=' Your Library'/>
                    {drawerItems.library ? <ExpandLess/> : <ExpandMore/>}
                </MenuItem>
                <Collapse in={drawerItems.library} sx={{mb: 2}}>
                    <MenuItem sx={{marginLeft: 3}}
                              onClick={() => {
                                  dispatch(setGroupSelection(''))
                                  navigate('/library/favorites')
                              }}
                              selected={(location.pathname === '/library/favorites') ? true: false}
                    >
                        <ListItemIcon>
                            <FavoriteIcon/>
                        </ListItemIcon>
                        <ListItemText primary='Favorites'/>
                    </MenuItem>
                    <MenuItem sx={{marginLeft: 3}}
                              onClick={() => {
                                  dispatch(setGroupSelection(''))
                                  navigate('/library/recent')
                              }}
                              selected={(location.pathname === '/library/recent') ? true : false}
                    >
                        <ListItemIcon>
                            <HistoryIcon/>
                        </ListItemIcon>
                        <ListItemText primary='Recently Viewed'/>
                    </MenuItem>

                </Collapse>
                <Divider/>
            </MenuList>
            <MenuList>
                <MenuItem onClick={() => {
                    dispatch(setDrawerItem({item: "techniques", value: true}))
                    dispatch(setDrawerItem({item: "classes", value: drawerItems.classes}))
                }}
                          selected={(location.pathname.indexOf('/search') > -1 && searchParams.get('categories')) ? true : false}
                          sx={{mt: 2}}
                >
                    <ListItemIcon>
                        <SpokeIcon/>
                    </ListItemIcon>
                    <ListItemText primary='Class Types'/>
                    {drawerItems.classes ? <ExpandLess/> : <ExpandMore/>}
                </MenuItem>
                <Collapse in={drawerItems.classes}>
                    {(taxData && !taxLoading && !taxError) &&
                        findParent('Classes', classes).map((item, index) => (
                            <div key={`menu-${item.name}-${index}`}>
                                <FormControl>
                                    <RadioGroup>
                                        <MenuItem sx={{ml: 4}}>
                                            {item.name}
                                        </MenuItem>
                                        <Collapse in={true} sx={{ml: 4}}>
                                            <MenuItem sx={{marginLeft: 4}}>
                                                <FormGroup>
                                                    {findParent(item.name, classes).map((child, childIndex) => (
                                                        <FormControlLabel key={`child-${item.name}-${childIndex}`}
                                                                          control={<Radio/>}
                                                                          label={child.name}
                                                                          value={child.id}
                                                                          checked={(searchParams.get('categories') === child.id)}
                                                                          onChange={handleClassChildSelect}
                                                        />
                                                    ))
                                                    }
                                                </FormGroup>
                                            </MenuItem>
                                        </Collapse>
                                    </RadioGroup>
                                </FormControl>
                            </div>
                        ))
                    }
                </Collapse>
                <Divider/>
            </MenuList>
            {searchParams.get('categories') &&
                <MenuList>
                    <MenuItem onClick={() => {
                        dispatch(setDrawerItem({item: "techniques", value: drawerItems.techniques}))
                        dispatch(setDrawerItem({item: "classes", value: true}))
                    }}
                              selected={(location.pathname.indexOf('/search') > -1 && searchParams.get('techniques')) ? true: false}
                              sx={{mt: 2}}
                    >
                        <ListItemIcon>
                            <Tornado/>
                        </ListItemIcon>
                        <ListItemText primary='Techniques'/>
                        {drawerItems.techniques ? <ExpandLess/> : <ExpandMore/>}
                    </MenuItem>
                    <Collapse in={drawerItems.techniques}>
                        {(taxData && !taxLoading && !taxError && drawerItems.techniques) &&
                            <MemoMenu/>
                        }
                    </Collapse>
                </MenuList>
            }
            {searchParams.get('categories') &&
                <>
                    <MenuList>
                        <MenuItem onClick={() => {
                            dispatch(setDrawerItem({item: "instructors", value: drawerItems.instructors}))
                            if (!drawerItems.instructors) {
                                getInstructors()
                            }
                        }}
                                  selected={(searchParams.get('instructors')) ? true : false}
                        >
                            <ListItemIcon>
                                <PersonPinIcon/>
                            </ListItemIcon>
                            <ListItemText primary='Instructor'/>
                            {drawerItems.instructors ? <ExpandLess/> : <ExpandMore/>}
                        </MenuItem>
                    </MenuList>
                    <Collapse in={drawerItems.instructors} style={{minHeight: 'auto'}}>
                        <List>
                            {insLoading &&
                                <ListItem sx={{marginLeft: "20px"}}>
                                    <Spinner/>
                                </ListItem>
                            }
                            <FormGroup>
                                {(insData && !insLoading && !insError) &&
                                    instructors.objects.map((item, index) => (
                                        <ListItem
                                            key={`instructor-drawer-${index}`}
                                            sx={{marginLeft: "20px"}}
                                        >
                                            <FormControlLabel
                                                control={<Checkbox value={item.id} checked={instructorCheck(item.id)}/>}
                                                label={item.name}
                                                onChange={handleInstructorChange}
                                            />
                                        </ListItem>
                                    ))
                                }
                            </FormGroup>

                        </List>
                    </Collapse>
                    <Divider/>

                </>
            }

        </Box>
    )

    return (
        <Box sx={{display: 'flex'}}>

            <Drawer
                sx={{
                    display: {xs: 'none', md: 'block'},
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                        top: '65px',
                        bgcolor: '#ffffff',
                        height: 'calc(100% - 65px)',
                        overflowX: 'hidden'
                    },
                }}
                variant="permanent"
                anchor="left"
                open
            >
                {drawer}
            </Drawer>

            <Drawer
                container={container}
                variant="temporary"
                open={drawerOpen}
                onClose={() => {
                    dispatch(setDrawerOpen(false))
                }}
                ModalProps={{
                    keepMounted: true,
                }}
                sx={{
                    display: {xs: 'block', md: 'none'},
                    '& .MuiDrawer-paper': {boxSizing: 'border-box', width: '85%'},
                }}
            >
                {drawer}
            </Drawer>
        </Box>

    )


}

export default DashboardDrawer